export default "__VITE_ASSET__Blr5quOy__"